import Glide from '@glidejs/glide'
import tabs from 'tabs'

import '@glidejs/glide/dist/css/glide.core.min.css'
import '@glidejs/glide/dist/css/glide.theme.min.css'

var container = document.querySelector('#product-tabs')

if (!container) {
  return
}
new tabs(container)

var more_photos = document.querySelector(
  '#carousel-imgs-produto .glide__arrows'
)

if (more_photos) {
  const glide = new Glide('#carousel-imgs-produto', {
    type: 'carousel',
    perView: 1,
    gap: 0,
  })

  glide.mount()
}

if (window.location.search.includes('tab=composicao')) {
  document.querySelector('#btn-tab-composicao').click()
  document.querySelector('#btn-comprar').scrollIntoView({ behavior: 'smooth' })
}
